export const link = (tokens) => {
    const { link } = tokens.component;
    return {
        MuiLink: {
            styleOverrides: {
                root: {
                    color: link.color.value,
                    fontWeight: link.fontWeight.value,
                    textDecoration: link.textDecoration.value,
                    "&:hover": {
                        textDecoration: link.hover.textDecoration.value,
                        color: link.hover.color.value,
                    },
                },
            },
        },
    };
};
export default link;
//# sourceMappingURL=link.js.map